// Reuse the theme's existing cart request and drawer events.
customElements.whenDefined('liene-product-line').then(() => {
  if (customElements.get('liene-product-comparison')) return;
  const ProductLine = customElements.get('liene-product-line');
  const chevron = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m5 7.5 5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  customElements.define('liene-product-comparison', class extends ProductLine {
    connectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.headerObserver?.disconnect();
      this.abort = new AbortController(); const options = { signal: this.abort.signal };
      this.models = [...this.querySelectorAll('[data-model]')].map(node => ({ ...JSON.parse(node.dataset.model), block: node.dataset.blockId }));
      this.main = this.querySelector('[data-main-products]'); this.compact = this.querySelector('.lpc__compact');
      this.compactProducts = this.querySelector('[data-compact-products]'); this.table = this.querySelector('.lpc__table');
      this.rows = [...this.querySelectorAll('[data-row]')]; this.more = this.querySelector('.lpc__more');
      this.groups = [...this.table.querySelectorAll('.lpc__group')];
      this.desktop = this.models.map((_, group) => ({ group, option: 0 }));
      this.slots = this.initialMobileSlots();
      this.mobile = matchMedia('(max-width: 749px)');
      this.mobile.addEventListener('change', () => { if (!this.pending) this.render(); this.setExpanded(!this.mobile.matches); }, options);
      this.render(); this.setExpanded(!this.mobile.matches);
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose]'), swatch = event.target.closest('[data-color]'), add = event.target.closest('[data-add]');
        if (choice) this.choose(Number(choice.dataset.slot), Number(choice.dataset.choose), choice);
        else if (swatch) this.color(Number(swatch.dataset.slot), Number(swatch.dataset.color), swatch);
        else if (add) this.addToCart(add);
        else if (event.target.closest('.lpc__more')) this.setExpanded(!this.expanded, true);
      }, options);
      // Native details keeps keyboard support without a custom listbox focus model.
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { const menu = event.target.closest('.lpc__selector'); if (menu?.open) { menu.open = false; menu.querySelector('summary').focus(); event.preventDefault(); } }
      }, options);
      this.addEventListener('toggle', event => {
        if (event.target.matches('.lpc__selector') && event.target.open) this.querySelectorAll('.lpc__selector[open]').forEach(menu => { if (menu !== event.target) menu.open = false; });
        if (event.target.matches('.lpc__group')) this.syncExpansionState();
        this.scheduleSticky();
      }, { ...options, capture: true });
      document.addEventListener('click', event => { if (!event.target.closest('.lpc__selector')) this.querySelectorAll('.lpc__selector[open]').forEach(menu => { menu.open = false; }); }, options);
      this.addEventListener('shopify:block:select', event => {
        const group = event.target.closest('.lpc__group');
        if (group) { group.open = true; this.syncExpansionState(); }
        const model = event.target.closest('[data-block-id]');
        if (model && this.mobile.matches) this.choose(0, this.models.findIndex(item => item.block === model.dataset.blockId));
      }, options);
      window.addEventListener('scroll', () => this.scheduleSticky(), { ...options, passive: true });
      window.addEventListener('resize', () => this.scheduleSticky(), options);
      this.observer = new ResizeObserver(() => this.scheduleSticky());
      this.observer.observe(this.querySelector('.lpc__inner')); this.observer.observe(this.compact);
      this.headers = [...document.querySelectorAll('.lh-header, .shopify-section--header, .shopify-section--announcement-bar, [data-pxs-shortcut]')];
      this.headerTransitions = new Set();
      this.headerObserver = new MutationObserver(() => this.scheduleSticky());
      this.headers.forEach(header => {
        this.observer.observe(header);
        this.headerObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
        // The custom navigation slides independently of scroll events. Follow its
        // rendered edge throughout the transition, including after scrolling stops.
        header.addEventListener('transitionrun', event => {
          if (event.target !== header || !['transform', 'top'].includes(event.propertyName)) return;
          this.headerTransitions.add(header); this.scheduleSticky();
        }, options);
        ['transitionend', 'transitioncancel'].forEach(type => header.addEventListener(type, event => {
          if (event.target !== header || !['transform', 'top'].includes(event.propertyName)) return;
          this.headerTransitions.delete(header); this.scheduleSticky();
        }, options));
      });
      this.scheduleSticky();
    }
    initialMobileSlots() {
      const selected = [this.dataset.mobileProduct1, this.dataset.mobileProduct2].map(id => {
        if (!id) return null;
        const group = this.models.findIndex(model => model.options.some(item => String(item.id) === String(id)));
        return group < 0 ? null : { group, option: this.models[group].options.findIndex(item => String(item.id) === String(id)) };
      });
      if (this.models.length < 2) return this.models.length ? [selected[0] || selected[1] || { group: 0, option: 0 }] : [];
      if (selected[0] && selected[1]?.group === selected[0].group) selected[1] = null;
      return selected.slice(0, Math.min(2, this.models.length)).map((slot, index) => {
        if (slot) return slot;
        const used = selected.filter(Boolean).map(item => item.group);
        const group = this.models[index] && !used.includes(index) ? index : this.models.findIndex((_, i) => !used.includes(i));
        selected[index] = { group, option: 0 };
        return selected[index];
      });
    }
    views() { return this.mobile.matches ? this.slots : this.desktop; }
    product(slot) { const view = this.views()[slot]; return this.models[view.group].options[view.option]; }
    node(tag, className, text) { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; }
    image(product, className = '') {
      const image = this.node('img', className); image.alt = product.title; image.width = 140; image.height = 140;
      if (product.image) image.src = product.image; else image.hidden = true;
      return image;
    }
    selector(slot, product) {
      const details = this.node('details', 'lpc__selector'), summary = this.node('summary');
      summary.setAttribute('aria-label', `${this.dataset.switchLabel}: ${product.title}`);
      summary.append(this.node('span', '', product.title)); summary.insertAdjacentHTML('beforeend', chevron); details.append(summary);
      const menu = this.node('div', 'lpc__options');
      this.models.forEach((model, index) => {
        const button = this.node('button'); button.type = 'button'; button.dataset.choose = index; button.dataset.slot = slot;
        button.setAttribute('aria-pressed', String(this.views()[slot].group === index));
        if (this.dataset.hideImages !== 'true') button.append(this.image(model.options[0]));
        button.append(this.node('span', '', model.label)); menu.append(button);
      });
      details.append(menu); return details;
    }
    card(slot, compact) {
      const view = this.views()[slot], model = this.models[view.group], product = model.options[view.option];
      const showActions = !compact || (this.dataset.stickyActions === 'true' && !this.mobile.matches);
      const card = this.node('div', 'lpc__product' + (showActions ? ' lpg__card' : '')); card.dataset.slot = slot; card.product = product;
      const name = this.node('h3', 'lpc__name', product.title); name.title = product.title;
      if (this.dataset.hideImages === 'true') name.tabIndex = -1;
      card.append(name, this.selector(slot, product));
      if (this.dataset.hideImages !== 'true') {
        const link = this.node('a', 'lpc__image'); link.href = product.url; link.setAttribute('aria-label', product.title); link.append(this.image(product)); card.append(link);
      }
      if (showActions) {
        const colors = this.node('div', 'lpc__swatches'); colors.setAttribute('role', 'group'); colors.setAttribute('aria-label', this.dataset.colorLabel);
        if (model.options.length > 1) model.options.forEach((item, index) => {
          const swatch = this.node('button', 'lpc__swatch'); swatch.type = 'button'; swatch.dataset.color = index; swatch.dataset.slot = slot;
          // The parent cart integration temporarily disables controls with data-option.
          swatch.dataset.option = ''; swatch.setAttribute('aria-label', item.colorName); swatch.title = item.colorName;
          swatch.setAttribute('aria-pressed', String(view.option === index)); swatch.style.setProperty('--swatch', item.color);
          const dot = this.node('span'); if (item.swatchImage) dot.style.backgroundImage = `url(${JSON.stringify(item.swatchImage)})`;
          swatch.append(dot); colors.append(swatch);
        });
        card.append(colors);
        if (this.dataset.showAddToCart === 'true') {
          const actions = this.node('div', 'lpc__actions'); const add = this.node('button', '', product.requiresPlan ? this.dataset.optionsLabel : product.available ? this.dataset.addLabel : this.dataset.soldLabel);
          add.type = 'button'; add.dataset.add = ''; add.disabled = !product.available; actions.append(add);
          const feedback = this.node('p', 'lpc__feedback lpg__status'); feedback.setAttribute('role', 'status'); feedback.setAttribute('aria-live', 'polite');
          card.append(actions, feedback);
        }
      }
      return card;
    }
    comparisonKey(row, raw) {
      if (raw === null || raw === undefined || raw === '') return null;
      if (row.dataset.format === 'list') {
        const items = (Array.isArray(raw) ? raw : String(raw).split(/\r?\n/))
          .map(item => String(item).replace(/^\s*[•·]\s*/, '').trim()).filter(Boolean);
        return items.length ? JSON.stringify(items) : null;
      }
      const text = String(raw).replace(/\r\n/g, '\n').trim();
      return text || null;
    }
    mergeIdentical(row) {
      if (this.dataset.mergeIdentical !== 'true' || this.desktop.length < 2) return;
      // Compare all kits, even when mobile currently displays only two of them.
      const keys = this.desktop.map(view => this.comparisonKey(row, this.models[view.group].options[view.option].specs[row.dataset.row]));
      if (keys[0] === null || !keys.every(key => key === keys[0])) return;
      const cells = [...row.querySelectorAll('.lpc__value')];
      const shared = cells[0];
      if (!shared) return;
      shared.classList.add('lpc__value--shared');
      shared.removeAttribute('data-col');
      shared.setAttribute('aria-label', `${this.views().map((_, slot) => this.product(slot).title).join(' / ')}: ${shared.textContent}`);
      cells.slice(1).forEach(cell => cell.remove());
    }
    render() {
      this.renderedMobile = this.mobile.matches;
      this.style.setProperty('--lpc-columns', this.views().length || 2);
      this.main.replaceChildren(this.node('div', 'lpc__spacer')); this.compactProducts.replaceChildren(this.node('div', 'lpc__spacer'));
      this.views().forEach((_, slot) => { this.main.append(this.card(slot, false)); this.compactProducts.append(this.card(slot, true)); });
      this.rows.forEach(row => {
        row.querySelectorAll('.lpc__value').forEach(cell => cell.remove());
        this.views().forEach((_, slot) => {
          const product = this.product(slot), raw = product.specs[row.dataset.row];
          const value = raw === null || raw === undefined || raw === '' ? this.dataset.emptyLabel : String(raw);
          const cell = this.node('div', 'lpc__value', /^no$/i.test(value.trim()) ? '×' : value);
          if (row.dataset.format === 'list' && raw !== null && raw !== undefined && raw !== '') {
            const items = (Array.isArray(raw) ? raw : String(raw).split(/\r?\n/))
              .map(item => String(item).replace(/^\s*[•·]\s*/, '').trim()).filter(Boolean);
            if (items.length) {
              const list = this.node('ul');
              items.forEach(item => list.append(this.node('li', '', item)));
              cell.replaceChildren(list);
            }
          }
          cell.dataset.col = slot; cell.setAttribute('aria-label', `${product.title}: ${value}`); row.append(cell);
        });
      });
      this.rows.forEach(row => this.mergeIdentical(row));
      this.main.hidden = !this.models.length; this.table.hidden = !this.models.length;
      const setup = this.querySelector('[data-setup]'); if (setup) setup.hidden = !!this.models.length;
      this.scheduleSticky();
    }
    choose(slot, group, trigger) {
      if (this.pending || group < 0 || !this.models[group] || !this.views()[slot]) return;
      const inCompact = !!trigger?.closest('.lpc__compact');
      this.views()[slot] = { group, option: 0 }; this.render();
      (inCompact ? this.compactProducts : this.main).querySelector(`[data-slot="${slot}"] .lpc__selector summary`)?.focus({ preventScroll: true });
    }
    color(slot, option) {
      if (this.pending || !this.views()[slot] || !this.models[this.views()[slot].group].options[option]) return;
      this.views()[slot].option = option; this.render();
      this.main.querySelector(`[data-slot="${slot}"][data-color="${option}"]`)?.focus({ preventScroll: true });
    }
    async addToCart(button) {
      if (this.pending) return;
      this.pending = true;
      this.querySelectorAll('.lpc__selector').forEach(menu => { menu.open = false; menu.inert = true; });
      try { await super.addToCart(button); }
      finally {
        this.pending = false; this.querySelectorAll('.lpc__selector').forEach(menu => { menu.inert = false; });
        // A resize during a request must not detach the button/status receiving its result.
        if (this.renderedMobile !== this.mobile.matches) this.render();
        this.scheduleSticky();
      }
    }
    setExpanded(expanded, fromClick = false) {
      const openingRows = this.groups.filter(group => !group.open).flatMap(group => [...group.querySelectorAll('[data-row]')]);
      // Collapse whole groups, retaining every heading and all of Basic Information.
      this.rows.forEach(row => { row.hidden = false; });
      this.groups.forEach((group, index) => { group.hidden = false; group.open = expanded || index === 0; });
      this.syncExpansionState();
      if (fromClick && expanded && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        openingRows.filter(row => row.offsetHeight).forEach(row => row.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260 }));
      }
      if (fromClick && !expanded && this.more.getBoundingClientRect().top < this.topOffset()) this.more.scrollIntoView({ block: 'center', behavior: 'instant' });
      this.scheduleSticky();
    }
    syncExpansionState() {
      this.expanded = this.groups.length > 0 && this.groups.every(group => group.open);
      this.more.hidden = !this.models.length || this.groups.length < 2;
      this.more.setAttribute('aria-expanded', String(this.expanded));
      this.more.querySelector('[data-more]').hidden = this.expanded;
      this.more.querySelector('[data-less]').hidden = !this.expanded;
    }
    topOffset() {
      let top = 0;
      (this.headers || []).forEach(header => {
        const rect = header.getBoundingClientRect(), style = getComputedStyle(header);
        if (['sticky', 'fixed'].includes(style.position) && style.visibility !== 'hidden' && style.display !== 'none' && header.getAttribute('aria-hidden') !== 'true' && rect.height > 0 && rect.bottom > 0 && rect.top <= top + 2) top = Math.max(top, rect.bottom);
      });
      return top + (Number(this.dataset.offset) || 0);
    }
    scheduleSticky() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.updateSticky(); });
    }
    collapseProducts(collapsed) {
      if (this.main.classList.contains('is-collapsed') === collapsed) return;
      // Prevent the browser anchoring a parameter/FAQ row and undoing the
      // height change with an automatic scroll, which would retrigger expansion.
      this.restoreScrollAnchor?.();
      const scroller = document.scrollingElement;
      const previous = scroller.style.overflowAnchor;
      scroller.style.overflowAnchor = 'none';
      this.restoreScrollAnchor = () => {
        cancelAnimationFrame(this.anchorFrame);
        scroller.style.overflowAnchor = previous;
        this.restoreScrollAnchor = null;
      };
      this.anchorFrame = requestAnimationFrame(() => {
        this.anchorFrame = requestAnimationFrame(() => this.restoreScrollAnchor?.());
      });
      this.main.classList.toggle('is-collapsed', collapsed);
      this.main.inert = collapsed;
      this.main.setAttribute('aria-hidden', String(collapsed));
      if (collapsed) this.main.querySelectorAll('.lpc__selector[open]').forEach(menu => { menu.open = false; });
    }
    updateSticky() {
      if (!this.isConnected || !this.table) return;
      const top = this.topOffset(), inner = this.querySelector('.lpc__inner').getBoundingClientRect();
      this.style.setProperty('--lpc-sticky-top', `${top}px`); this.style.setProperty('--lpc-sticky-left', `${inner.left}px`); this.style.setProperty('--lpc-sticky-width', `${inner.width}px`);
      this.style.setProperty('--lpc-compact-height', `${this.compact.offsetHeight}px`);
      const titleTop = this.main.getBoundingClientRect().top;
      const sticky = this.dataset.sticky === 'true' && !!this.models.length && titleTop <= top;
      // Mobile overlays the scrolling cards; desktop replaces their full height.
      const collapsed = sticky && !this.mobile.matches;
      const mainFocus = collapsed && this.main.contains(document.activeElement) ? document.activeElement.closest('[data-slot]')?.dataset.slot : null;
      // Stay collapsed past the table's end; expanding there changes the end
      // position and makes the fixed header repeatedly enter and leave view.
      this.collapseProducts(collapsed);
      const bounds = this.table.getBoundingClientRect();
      const visible = sticky && bounds.bottom > top;
      const hadFocus = this.compact.contains(document.activeElement);
      this.compact.classList.toggle('is-visible', visible); this.compact.inert = !visible; this.compact.setAttribute('aria-hidden', String(!visible));
      this.compact.style.transform = `translateY(${Math.min(0, bounds.bottom - top - this.compact.offsetHeight)}px)`;
      if (visible && mainFocus !== null) this.compactProducts.querySelector(`[data-slot="${mainFocus}"] ${this.mobile.matches ? '.lpc__selector summary' : this.dataset.hideImages === 'true' ? '.lpc__name' : '.lpc__image'}`)?.focus({ preventScroll: true });
      if (!visible && hadFocus) this.more.focus({ preventScroll: true });
      if (this.headerTransitions?.size) this.scheduleSticky();
    }
    disconnectedCallback() {
      this.restoreScrollAnchor?.();
      this.abort?.abort(); this.observer?.disconnect(); this.headerObserver?.disconnect(); this.headerTransitions?.clear(); cancelAnimationFrame(this.frame); this.frame = null;
    }
  });
});
